import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/group/[id]/page.tsx");
